<script lang="ts">
  import Label from '$provider/constants/Label';

  interface Props {
    titleArr?: Array<string>;
    children?: import('svelte').Snippet;
  }

  let { titleArr = [], children }: Props = $props();
  let title =
    $derived((Array.isArray(titleArr) &&
      titleArr.length > 0 &&
      `${titleArr.join(' - ')} - ${Label.VerifiableLabel}`) ||
    Label.VerifiableLabel);
</script>

<svelte:head>
  <title>{title || Label.VerifiableLabel}</title>
</svelte:head>
{@render children?.()}
